import DocumentPage from './DocumentPage';

export const parentDocument = {
  slug: 'parent',
  route: '/parent',
  title: 'Parent',
  category: 'Academics',
  format: 'DOCX',
  description:
    'The Parent module in EduX ERP stores guardian records, captures relationship and identity details, and links each parent with the relevant student records.',
  metrics: [
    { label: 'Primary focus', value: 'Guardian records' },
    { label: 'Core records', value: 'Parents and students' },
    { label: 'Tracking', value: 'Relation and contact details' },
  ],
  workflow: [
    'Go to Parents and click New to create a new parent record.',
    'Enter the parent name, relationship with the student, email, and Aadhaar number.',
    'Link the parent to the required student records so contact and academic references stay connected.',
  ],
  sections: [
    {
      id: 'introduction',
      title: 'Introduction',
      body: [
        'Odoo allows you to store the details of the parents and their students.',
        'This module helps schools keep guardian information together with the student records that depend on it for communication and administration.',
      ],
    },
    {
      id: 'parent-record',
      title: 'Parent Record',
      body: [
        'Go to Parents and click New to create a new parent record.',
        'The parent form captures guardian details such as name, relation with student, email, Aadhaar number, and the list of linked students.',
      ],
      figure: {
        src: '/assets/doc-images/parent/image1.png',
        alt: 'Parent record showing guardian details and linked student records',
        caption:
          'Parent form showing the guardian profile, relation with student, contact information, Aadhaar number, and linked student entries.',
      },
      bullets: [
        'Store the parent name and contact information in one record.',
        'Set the relationship between the guardian and the student.',
        'Maintain linked student details directly from the Student(s) section.',
      ],
    },
    {
      id: 'parent-fields',
      title: 'Details of Parent',
      body: [
        'The following fields are maintained while creating or reviewing a parent profile.',
      ],
      detailCards: [
        {
          title: 'Guardian information',
          bullets: [
            'Name: provide the name of the parent from the list.',
            'Relation with Student: select the relation of the user with the student.',
            'Email: provide the email of the parent.',
            'Aadhaar Number: provide the Aadhaar number.',
          ],
        },
        {
          title: 'Student linkage',
          bullets: [
            'Students: select the students for whom the parent is created.',
            'Use the linked student table to keep guardian and learner records connected.',
          ],
        },
      ],
    },
    {
      id: 'student-linkage',
      title: 'Student Linkage',
      body: [
        'Each parent record can be linked with student records so schools can manage contact and academic relationships more clearly.',
      ],
      bullets: [
        'Select the student set connected to the guardian profile.',
        'Use parent linkage to support communication, admissions follow-up, and profile completeness.',
      ],
    },
  ],
  related: ['student', 'admission'],
};

export default function ParentPage() {
  return <DocumentPage document={parentDocument} />;
}
